import React from "react";
import styles from "./FeaturedStatisticsList.module.scss";
import { SanityFeaturedStatisticsList } from "../../model/common";
import Text from "../Text/Text";
import classNames from "classnames";

interface FeaturedStatisticsListProps {
  node: SanityFeaturedStatisticsList;
  layout?: "default" | "prominent";
}

const FeaturedStatisticsList = ({
  node: { statistics },
  layout = "default"
}: FeaturedStatisticsListProps) => (
  <div
    className={classNames(
      styles.root,
      { [styles.prominent]: layout === "prominent" }
    )}
  >
    <ul>
      {statistics?.map(({ statistic, text }, index) => (
        <li key={index}>
          <Text variant="h3" as="span" className={styles.statistic}>
            {statistic}
          </Text>
          <Text variant="defaultLight" as="span" className={styles.text}>
            {text}
          </Text>
        </li>
      ))}
    </ul>
  </div>
);

export default FeaturedStatisticsList;
